// extracted by mini-css-extract-plugin
export default {"status":"Status_status__xy1KL","status__innerWrapper":"Status_status__innerWrapper__C3ZVI"};